import { getRealNameAuthAPI, getUserInfoAPI, logoutUserAPI } from '@/service'
import { mergeStep } from '@/utils'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore(
  'user',
  () => {
    const userInfo = ref<IUserInfo | null>(null)
    const token = ref('')

    const loadUserInfo = mergeStep(async () => {
      const res = await getUserInfoAPI()
      userInfo.value = res.data.userinfo
      userInfo.value.commission_money = res.data?.moneyyong

      // 根据 is_fund_unfreeze 设置金额展示：冻结中 / 已解冻（已解冻时显示实际金额）
      const unfrozen = !!userInfo.value?.is_fund_unfreeze
      ;(userInfo.value as any).money_display = unfrozen
        ? `${userInfo.value?.money}(解冻中)`
        : `${userInfo.value?.money}(冻结中)`
      ;(userInfo.value as any).valid_amount_display = unfrozen
        ? `${userInfo.value?.valid_amount}(解冻中)`
        : `${userInfo.value?.valid_amount}(冻结中)`

      getRealNameAuthAPI().then((res) => {
        if (Number(res.data?.status) !== 2) {
          uni.reLaunch({
            url: '/pages-sub/realname/index',
          })
        }
        userInfo.value.realname = res.data?.realname

        return res.data
      })
    })

    const setUserInfo = (val: IUserInfo) => {
      userInfo.value = val
    }
    const setToken = (val: string) => {
      token.value = val
    }

    const clearUserInfo = () => {
      userInfo.value = null
    }
    const clearToken = () => {
      token.value = ''
    }
    const logout = async () => {
      // logoutUserAPI()
      clearUserInfo()
      clearToken()
    }

    const isLogged = computed(() => !!token.value)

    return {
      userInfo,
      loadUserInfo,
      setUserInfo,
      clearUserInfo,
      isLogged,
      setToken,
      token,
      logout,
    }
  },
  {
    persist: true,
  },
)
